import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import i18n from './i18n'
// import "./css/aprs.css";
// import './css/aprs-symbols.css';

function ready() {
        createApp(App).use(i18n).mount('#app');
    }

document.addEventListener("DOMContentLoaded", ready);
